export const GET_TOKEN = 'GET_TOKEN';
export const SET_TOKEN = 'SET_TOKEN';
export const TOKEN = 'TOKEN';


export function getToken() {
  return { type: GET_TOKEN };
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    token,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/token.js